import script from "./ModalTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./ModalTemplate.vue?vue&type=style&index=0&id=7ac651af&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac651af"]])

export default __exports__